import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';
import { environment } from 'src/environments/environment';
import swal from 'sweetalert2';
import { AccountService } from '../../../core/services/account.service';
import { SessionTimerService } from '../../../core/services/session-timer.service';
import { lastValueFrom, Subscription, switchMap, timer } from 'rxjs';
@Component({
  selector: 'app-aadhaar-verification',
  templateUrl: './aadhaar-verification.component.html',
  styleUrls: ['./aadhaar-verification.component.scss'],
})
export class AadhaarVerificationComponent implements OnInit {
  @Input() apiUrl!: string;
  @Input() aadhaarOTPGenerated: boolean = false;
  @Input() documentNumber: string;
  @Input() initiateUKYC: boolean;
  @Output() apiResponse = new EventEmitter();

  public myForm: UntypedFormGroup;
  public myForm1: UntypedFormGroup;
  resetButtonEnable: boolean = false;
  timeRemaining: number = 60;
  private timerSubscription: Subscription | undefined;
  private timerKey: string = 'otpTimer';
  startTime: number;

  baseUrl!: string;
  constructor(private router: Router, private formBuilder: UntypedFormBuilder, private http: HttpClient, private spinner: NgxSpinnerService, private accountService: AccountService, private sessionTimerService: SessionTimerService) {
    this.baseUrl = environment.apiUrl + 'assistmodule/v1/createUserProfile';
    // this.myForm = formBuilder.group({
    //   documentNumber: [
    //     '',
    //     [Validators.required, Validators.pattern('^[0-9]{12}$')],
    //   ],
    //   requestCode: ['5025'],
    //   aadhaarRequestType: ['initiate'],
    // });

    // this.myForm1 = formBuilder.group({
    //   documentNumber: [
    //     '',
    //     [Validators.required, Validators.pattern('^[0-9]{12}$')],
    //   ],
    //   requestCode: ['5021'],
    //   aadhaarRequestType: ['initiate'],
    // });
  }

  get m() {
    return this.myForm.controls;
  }

  get s() {
    return this.myForm1.controls;
  }

  // onSubmit() {
  //   console.log(this.myForm.value);
  //   this.spinner.show();
  //   return this.http.post(this.baseUrl, this.myForm.value).subscribe({
  //     next: (response: any) => {
  //       console.log(response);
  //       this.spinner.hide();
  //       if (response['error'] == null) {
  //         this.aadhaarOTPGenerated = true;
  //         swal.fire('Aadhaar OTP Sent');
  //         this.myForm.reset();
  //       } else {
  //         swal.fire(
  //           response['error']['response_msg'] == null ||
  //             response['error']['response_msg'] == ''
  //             ? response['error']['response_summary']
  //             : response['error']['response_msg']
  //         );
  //       }
  //       this.apiResponse.emit();
  //     },
  //   });
  // }

  // onSubmitOtp() {
  //   this.myForm1.value['docType'] = this.myForm1.value['docType'] == null ? 'address proof' : this.myForm1.value['docType'];
  //   this.myForm1.value['requestCode'] = this.myForm1.value['requestCode'] == null ? '5021' : this.myForm1.value['requestCode'];
  //   this.myForm1.value['subDocType'] = this.myForm1.value['subDocType'] == null ? 'aadhaar' : this.myForm1.value['subDocType'];
  //   console.log(this.myForm1.value);
  //   this.spinner.show();
  //   return this.http.post(this.baseUrl, this.myForm1.value).subscribe({
  //     next: (response: any) => {
  //       console.log(response);
  //       this.spinner.hide();
  //       if (response['error'] == null) {
  //         this.aadhaarOTPGenerated = true;
  //         //swal.fire('Aadhaar OTP Verified Successfully!');
  //         swal.fire({
  //           text: 'Aadhaar OTP Verified Successfully!',
  //           //icon: 'info',
  //           confirmButtonText: 'OK'
  //         }).then((result) => {
  //           if (result.isConfirmed) {
  //             this.myForm1.reset();
  //             let user = JSON.parse(MemoryStorageService.getItem('user'));
  //             this.router.navigateByUrl('/assist-journey/professional-details');
  //           }
  //         });
  //       }
  //       else if (response['error']['response_msg'] == 'Please verify aadhaar otp again!') {
  //         swal.fire('Please verify aadhaar otp again!');
  //       }
  //       else if (response['error']['response_summary'] == 'User is declined') {
  //         this.router.navigateByUrl('/assist-journey/sorry');
  //       }
  //       else {
  //         let user = JSON.parse(MemoryStorageService.getItem('user'));
  //         this.router.navigateByUrl('/assist-journey/professional-details');
  //       }
  //       this.apiResponse.emit();
  //     },
  //   });
  // }

  async ngOnInit(): Promise<void> {
    this.spinner.show();
    //this.sessionTimerService.resumeTimer();
    console.log('ngOnInit');
    this.startTimer();

    if (this.initiateUKYC) {
      var res = await lastValueFrom(this.accountService.GenerateUKYC());
      if (res['data'] != null) {
        this.spinner.hide();
        window.location.href = res['data'];
        return;
      }
      else {
        this.router.navigateByUrl('/assist-journey/session-expired');
        return;
      }
    }
    //Check if aadhaar doc exist and it is success verify
    // this.myForm = this.formBuilder.group({
    //   documentNumber: [
    //     '',
    //     [Validators.required, Validators.pattern('^[0-9]{12}$')],
    //   ],
    //   requestCode: ['5025'],
    //   aadhaarRequestType: ['initiate'],
    // });
    // this.myForm1 = this.formBuilder.group({
    //   aadhaarOtp: ['', [Validators.required, Validators.pattern('^[0-9]{6}$')]],
    //   requestCode: ['5021'],
    //   docType: ['address proof'],
    //   subDocType: ['aadhaar'],
    // });
    // // let documentType = 'address proof';
    // // this.accountService.getLatestDocument(documentType).subscribe(
    // //   (res) => {
    // //     console.log(res);
    // //     if (res.status == 'Success' && res.api == 'VERIFY') {
    // //     }else{
    // //       this.myForm.controls.documentNumber.setValue(res.documentNumber);
    // //       this.onSubmit();
    // //     }
    // //   }
    // // )
    // if (this.documentNumber != null && this.documentNumber != '') {
    //   this.myForm.controls.documentNumber.setValue(this.documentNumber);
    //   this.onSubmit();
    // }

  }
  // onResendOTP() {
  //   this.spinner.show();
  //   let objResendAadhaarOtp =
  //   {
  //     requestCode: '5025',
  //     aadhaarRequestType: 'resend'
  //   }
  //   try {
  //     this.accountService.ResendAadhaarOtp(objResendAadhaarOtp).subscribe({
  //       next: (response: any) => {
  //         this.spinner.hide();
  //         console.log(response);
  //         this.timeRemaining = 60;
  //         this.saveTimer();
  //         this.resetButtonEnable = false;
  //         this.startTimer();
  //         this.spinner.hide();
  //         if (response['error'] == null) {
  //           this.aadhaarOTPGenerated = true;
  //           swal.fire('Aadhaar OTP Resent');
  //           this.myForm1.reset();
  //         } else {
  //           swal.fire(
  //             response['error']['response_msg'] == null ||
  //               response['error']['response_msg'] == ''
  //               ? response['error']['response_summary']
  //               : response['error']['response_msg']
  //           );
  //         }
  //         this.apiResponse.emit();
  //       },

  //     });
  //   }
  //   catch (e) {
  //     this.spinner.hide();
  //     swal.fire({
  //       text: "Unable to Resend OTP",
  //       confirmButtonText: 'OK'
  //     });
  //   }

  // }
  startTimer(): void {
    const now = new Date().getTime();
    const savedExpiryTime = MemoryStorageService.getItem(this.timerKey);
    if (savedExpiryTime) {
      const expiryTime = parseInt(savedExpiryTime, 10);
      this.timeRemaining = Math.max(Math.floor((expiryTime - now) / 1000), 0);
      this.resetButtonEnable = this.timeRemaining === 0;
    }
    this.timerSubscription = timer(0, 1000).pipe(
      switchMap(() => {
        if (this.timeRemaining > 0) {
          this.timeRemaining--;
          this.saveTimer();
          return [this.timeRemaining];
        } else {
          this.resetButtonEnable = true;
          MemoryStorageService.removeItem(this.timerKey);
          if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
          }
          return [];
        }
      })
    ).subscribe();
  }

  saveTimer(): void {
    const expiryTime = new Date().getTime() + (this.timeRemaining * 1000);
    MemoryStorageService.setItem(this.timerKey, expiryTime.toString());
  }

  loadTimer(): void {
    const savedExpiryTime = MemoryStorageService.getItem(this.timerKey);
    if (savedExpiryTime) {
      const now = new Date().getTime();
      const expiryTime = parseInt(savedExpiryTime, 10);
      this.timeRemaining = Math.max(Math.floor((expiryTime - now) / 1000), 0);
      this.resetButtonEnable = this.timeRemaining === 0;
    }
  }

}
